import { classNames as cn } from "tools/ui";
import version from "../version";
const BASE_STYLE = "mx-auto py-5 bottom-0";

function Footer({ style }) {
  return (
    <footer className={cn(BASE_STYLE, style)}>
      <div className="mx-auto">
        <p className="text-center text-gray-400">
          Copyright© 2026 All rights reserved.
        </p>
        <p className="text-center text-gray-300">Version {version}</p>
        <a
          className="block text-center text-gray-600 hover:text-yellow-400"
          href="http://www.presik.com"
        >
          PRESIK SAS{" "}
        </a>
      </div>
    </footer>
  );
}

export default Footer;
